// import { EpolicyInit } from '@/assets/js/epolicyInit';

//显示弹框
const SHOW_MASK_LAYER = "SHOW_MASK_LAYER";
const HIDE_MASK_LAYER = "HIDE_MASK_LAYER";
//初始化信息
const AUTH_INIT = "AUTH_INIT";
//退出登录
const AUTH_SIGN_OUT = "AUTH_SIGN_OUT";
// 初始token
const TOKEN_INIT = "TOKEN_INIT";
const SHOW_PREVIEW_IMG = "SHOW_PREVIEW_IMG";
const SHOW_PREVIEW_IG = "SHOW_PREVIEW_IG";
const HIDE_PREVIEW_IMG = "HIDE_PREVIEW_IMG";
const LNGLAT_INIT = "LNGLAT_INIT"; //初始化城市经纬度
const CENTER_INIT = "CENTER_INIT"; //初始化城市经纬度
const USER_AUTH = "USER_AUTH"; //用户权限
const USER_INfO = "USER_AUTH"; //用户权限
const MENU_STATUS = "MENU_STATUS";
const MENUS = "MENUS";
const ONLINE_STATUS = "ONLINE_STATUS";
const IS_AUTH = "IS_AUTH";
const MyAccidentList = "MyAccidentList";
export default {
  changeCommand(state, payload) {
    state.command = payload;
  },
  [MENU_STATUS](state, payload) {
    state.menustatus = payload;
  },
  [MyAccidentList](state, payload) {
    state.myAccidentList = payload;
  },

  [SHOW_MASK_LAYER](state, payload) {
    state.showMaskFlag = true;
  },
  [HIDE_MASK_LAYER](state, payload) {
    state.showMaskFlag = false;
  },
  [TOKEN_INIT](state, payload) {
    state.token = payload.token;
  },
  [AUTH_INIT](state, payload) {
    state.userInfo = payload;
  },
  [AUTH_SIGN_OUT](state, payload) {
    state.userName = "";
    state.token = "";
    state.menus = [];
    // state.shoppingInfo = [];
  },
  [SHOW_PREVIEW_IMG](state, payload) {
    state.previewImgUrl = payload;
  },
  [SHOW_PREVIEW_IG](state, payload) {
    state.imgUrl = payload;
  },
  [HIDE_PREVIEW_IMG](state, payload) {
    state.previewImgUrl = "";
  },
  [LNGLAT_INIT](state, payload) {
    state.district = payload.district;
    state.center = [payload.center.lng, payload.center.lat];
  },
  [CENTER_INIT](state, payload) {
    state.center = payload;
  },
  [USER_AUTH](state, payload) {
    //console.log(payload)
    state.userAuth = payload;
  },
  [MENUS](state, payload) {
    //console.log(payload)
    state.menus = payload;
  },
  [ONLINE_STATUS](state, payload) {
    state.onlineStatus = payload;
  },
  [IS_AUTH](state, payload) {
    state.isAuth = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutation.js